import { Box, Typography, Button, Modal, Stack, useMediaQuery } from "@mui/material";
import React from "react";
import { useTheme } from "@mui/material/styles";

interface ConfirmDeleteModalMobileProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isDeleting: boolean;
}

const ConfirmDeleteModalMobile: React.FC<ConfirmDeleteModalMobileProps> = ({
  open,
  onClose,
  onConfirm,
  isDeleting,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute" as const,
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: isMobile ? "60%" : 300, // ✅ smaller & responsive
          bgcolor: "background.paper",
          boxShadow: 24,
          borderRadius: 2,
          p: 3,
          outline: "none",
        }}
      >
        <Typography variant="h6" fontWeight={600} mb={1.5}>
          Confirm Deletion
        </Typography>

        <Typography variant="body2" mb={3}>
          Are you sure you want to delete this tour program?
        </Typography>

        <Stack direction="row" spacing={2} justifyContent="flex-end">
          <Button
            variant="outlined"
            size="small"
            onClick={onClose}
            sx={{ minWidth: 80 }}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            color="error"
            size="small"
            onClick={onConfirm}
            disabled={isDeleting}
            sx={{ minWidth: 80 }}
          >
            {isDeleting ? "Deleting..." : "Delete"}
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default ConfirmDeleteModalMobile;
